import qs from "qs";
import FetchHelper from "./lib/fetchHelper";
import React from "react";
import { ReactRenderer } from "./lib/ReactRenderer";
/**
 * "Søg" (boards Soegning and Soegning - bred skaerm): a field and, under it, the pages that the
 * files matching the words belong to. Each hit says where the page is and why it matched.
 */
const ICON_PROPS = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true
};
class SearchComponent extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.inputRef = React.createRef();
        const search = qs.parse(location.search, { ignoreQueryPrefix: true });
        this.state = {
            search: (_a = search === null || search === void 0 ? void 0 : search.s) !== null && _a !== void 0 ? _a : '',
            busy: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.search = this.search.bind(this);
        this.submitSearch = this.submitSearch.bind(this);
    }
    componentDidMount() {
        this.inputRef.current.focus();
        this.search();
    }
    search(e = undefined) {
        if (this.state.search && this.state.search.length > 0) {
            this.setState({ busy: true });
            FetchHelper.post("/api/search", { terms: this.state.search })
                .then((result) => this.setState({ searchResults: result }))
                .finally(() => this.setState({ busy: false, dirty: false }));
        }
        e === null || e === void 0 ? void 0 : e.preventDefault();
    }
    submitSearch(e) {
        if (this.state.search && this.state.search.length > 0) {
            location.search = qs.stringify({ s: this.state.search }, { addQueryPrefix: true });
        }
        e.preventDefault();
    }
    handleChange(evt) {
        this.setState({ search: evt.target.value, dirty: true });
    }
    resultItem(item, idx) {
        const where = [item.path, item.date].filter((part) => part && part !== "").join(" · ");
        return (React.createElement("a", { className: "bi-sg-hit", href: item.url, key: `hit-${idx}` },
            React.createElement("span", { className: "bi-sg-hit-text" },
                React.createElement("span", { className: "bi-sg-hit-title" }, item.title),
                where ? React.createElement("span", { className: "bi-sg-hit-path" }, where) : null,
                item.excerpt ? React.createElement("span", { className: "bi-sg-hit-excerpt" }, item.excerpt) : null),
            React.createElement("svg", Object.assign({}, ICON_PROPS, { strokeWidth: 1.75, className: "bi-sg-hit-chevron" }),
                React.createElement("path", { d: "m9 6 6 6-6 6" }))));
    }
    render() {
        var _a;
        const results = (_a = this.state.searchResults) !== null && _a !== void 0 ? _a : [];
        const searched = !this.state.busy && !this.state.dirty && this.state.search && this.state.search.length > 0;
        return (React.createElement("div", { className: "bi-sg" },
            React.createElement("h1", null, "S\u00F8g"),
            React.createElement("form", { className: "bi-sg-form", role: "search", onSubmit: this.submitSearch },
                React.createElement("input", { ref: this.inputRef, type: "search", "aria-label": "S\u00F8g", value: this.state.search, onChange: this.handleChange }),
                React.createElement("button", { type: "submit", disabled: this.state.busy }, this.state.busy ? React.createElement("i", { className: "fa-solid fa-circle-notch fa-spin", "aria-label": "S\u00F8ger" }) : "Søg")),
            !this.state.busy && results.length > 0
                ? React.createElement("section", { className: "bi-sg-results" },
                    React.createElement("h2", null, "Resultater"),
                    React.createElement("div", { className: "bi-sg-card" }, results.map((item, idx) => this.resultItem(item, idx))))
                : null,
            searched && results.length === 0
                ? React.createElement("div", { className: "bi-sg-card bi-sg-empty" },
                    React.createElement("svg", Object.assign({}, ICON_PROPS, { strokeWidth: 1.5 }),
                        React.createElement("circle", { cx: "11", cy: "11", r: "7" }),
                        React.createElement("path", { d: "m20 20-3.5-3.5" })),
                    React.createElement("p", null, "S\u00F8gningen fandt ikke nogen emner."))
                : null));
    }
}
ReactRenderer.render("searchcomponent", (elem) => React.createElement(SearchComponent, Object.assign({}, (elem.dataset))));
